<div class="custom-checkbox" [class.disabled]="disabled">
    <input id="{{id}}" class="status"
           type="checkbox" [disabled]="disabled"
           [attr.checked]="checked ? 'checked' : null"
           [ngModel]="checked"
           (ngModelChange)="checked = !checked; checkedChange.emit(checked);"
           name="status">
    <label for="{{id}}">
        <div class="status-switch"
             role="button"
             tabindex="0"
             (keydown.enter)="toggleChecked()"
             (keydown.space)="toggleChecked()"
             data-unchecked=""
             data-checked="">
        </div>
    </label>
</div>
